export default class C{constructor(){}_s(){}changeUser(a){}clearData(){}}